<mat-form-field class="w-100 dense-2" [appearance]="appearance()">
  <mat-label *ngIf="label">{{ label() }}</mat-label>
  <input
    matInput
    [id]="id() ? 'input-' + id() : null"
    [placeholder]="placeholder()"
    [formControl]="formControlRef()"
    [email]="email()"
    [mask]="mask()"
    [type]="type()"
    [required]="required()"
    [dropSpecialCharacters]="dropSpecialCharacters()"
  />
  <button *ngIf="icon" matSuffix mat-icon-button>
    <mat-icon>{{ icon() }}</mat-icon>
  </button>

  <mat-hint>
    <ng-content select="[slot=hint]"> </ng-content>
  </mat-hint>
</mat-form-field>
